import React from 'react';
// import ReactDOM from 'react-dom';
import './index.scss';
import { createRoot } from 'react-dom/client';
import App from './App';
import { store } from './redux-store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Redirect from './components/redirect/Redirect';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const persistedStore = persistStore(store);


const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<h1>Loading</h1>} persistor={persistedStore}>
        <BrowserRouter>
          <Redirect />
          <App />
          <Toaster />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// root.unmount();

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <PersistGate loading={<h1>Loading</h1>} persistor={persistedStore}>
//         <BrowserRouter>
//           <Redirect />
//           <App />
//           <Toaster />
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
